import { IFiltroListagemEscala } from './models/escala.filtros.model';
import { ITrabalhadorListagemScheduler } from './models/escala.scheduler.model';

export class MeurhEscalaSchedulerColaboradoresService {

    public currentPage = 1;
    public totalItems = 0;
    public pageSize = 200;

    public filtros: IFiltroListagemEscala = {
        colaborador: {
            nome: 'Colaboradores',
            valor: []
        },
        situacao: {
            nome: 'Situação do colaborador',
            valor: ''
        },
        tipo: {
            nome: 'Tipo de colaborador',
            valor: null
        },
        departamento: {
            nome: 'Departamentos',
            valor: null
        },
        cargo: {
            nome: 'Cargos',
            valor: null
        },
        lotacao: {
            nome: 'Lotações',
            valor: null
        },
        horario: {
            nome: 'Horários',
            valor: null
        },
        grupodeponto: {
            nome: 'Grupos de ponto',
            valor: null
        },
        tipohorario: {
            nome: 'Tipo de horário',
            valor: false
        }
    };

    private _colaboradores: ITrabalhadorListagemScheduler[] = [];
    private _filtrosAtivos = false;

    constructor() {/**/}

    get colaboradores() {
        return this._colaboradores;
    }

    set colaboradores(colaboradores: ITrabalhadorListagemScheduler[]) {
        this._colaboradores = colaboradores;
        this.totalItems = colaboradores.length;
    }

    get filtrosAtivos() {
        return this._filtrosAtivos;
    }

    getColaboradoresDaPagina() {
        const colaboradores = this.filtraListagem();

        this.totalItems = colaboradores.length;

        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;

        return colaboradores.slice(start, end);
    }

    private filtraListagem() {
        let listagemFiltrada: ITrabalhadorListagemScheduler[] = [...this._colaboradores];

        const semFiltros = Object.values(this.filtros).every(x =>
            !this.valorExiste(x.valor) || (Array.isArray(x.valor) && x.valor.length === 0)
        );

        if (semFiltros) {
            this._filtrosAtivos = false;
            return listagemFiltrada;
        }

        this._filtrosAtivos = true;

        if (this.filtros.colaborador.valor.length > 0) {
            listagemFiltrada = listagemFiltrada.filter((colaborador) => {
                return this.filtros.colaborador.valor!.some((colab) => colab!.trabalhador === colaborador.colaboradorObj.trabalhador);
            });
        }
        if (this.filtros.situacao.valor) {
            listagemFiltrada = listagemFiltrada.filter((colaborador) => {
                return this.filtros.situacao.valor === colaborador.colaboradorObj.status;
            });
        }
        if (this.filtros.tipo.valor !== null) {
            listagemFiltrada = listagemFiltrada.filter((colaborador) => {
                return this.filtros.tipo.valor === colaborador.colaboradorObj.tipo;
            });
        }
        if (this.filtros.departamento.valor) {
            listagemFiltrada = listagemFiltrada.filter((colaborador) => {
                return this.filtros.departamento.valor!.departamento === colaborador.colaboradorObj.departamentoobj.departamento;
            });
        }
        if (this.filtros.cargo.valor) {
            listagemFiltrada = listagemFiltrada.filter((colaborador) => {
                return this.filtros.cargo.valor!.cargo === colaborador.colaboradorObj.cargoobj.cargo;
            });
        }
        if (this.filtros.lotacao.valor) {
            listagemFiltrada = listagemFiltrada.filter((colaborador) => {
                return this.filtros.lotacao.valor!.lotacao === colaborador.colaboradorObj.lotacaoobj.lotacao;
            });
        }
        if (this.filtros.horario.valor) {
            listagemFiltrada = listagemFiltrada.filter((colaborador) => {
                return this.filtros.horario.valor!.horario === colaborador.colaboradorObj.horario.horario;
            });
        }
        if (this.filtros.grupodeponto.valor) {
            listagemFiltrada = listagemFiltrada.filter((colaborador) => {
                return this.filtros.grupodeponto.valor!.grupo === colaborador.colaboradorObj.grupoobj.grupo;
            });
        }
        if (this.filtros.tipohorario.valor) {
            const TIPO_ESCALA = 6;
            listagemFiltrada = listagemFiltrada.filter((colaborador) => {
                return colaborador.colaboradorObj.eventos.horarios?.some(horario => horario.horario.tipo === TIPO_ESCALA);
            });
        }
        return listagemFiltrada;
    }

    private valorExiste(valor: unknown) {
		return valor !== '' && valor !== undefined && valor !== null && valor !== false ? true : false;
	}
}
